var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenGoodGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_860",
    "data-name": "Gruppe 860",
    transform: "translate(-218 -218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_879",
    "data-name": "Gruppe 879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_595",
    "data-name": "Ellipse 595",
    transform: "translate(218 218)",
    fill: "#dadada",
    stroke: "#707070",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_596",
    "data-name": "Ellipse 596",
    transform: "translate(225 225)",
    fill: "#010000",
    stroke: "#000001",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_597",
    "data-name": "Ellipse 597",
    transform: "translate(234 225)",
    fill: "#010000",
    stroke: "#000001",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1408",
    "data-name": "Pfad 1408",
    d: "M12,21a8.1,8.1,0,0,0,6,3,8.1,8.1,0,0,0,6-3",
    transform: "translate(213 212.983)",
    fill: "#dadada",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1407",
    "data-name": "Pfad 1407",
    d: "M0,0",
    transform: "translate(225 233.5)",
    fill: "none",
    stroke: "#010000",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenGoodGray);
export default __webpack_public_path__ + "static/media/green-good-gray.08551ae6.svg";
export { ForwardRef as ReactComponent };